import React from 'react'
import EndorsementForm from '../../components/EndorsementForm.js'
import StoryForm from '../../components/StoryForm.js'
import Img from 'gatsby-image'
import video from '../../img/stories/richard_overton/Overton_Impulse_FINAL.mp4'
import videoWebm from '../../img/stories/richard_overton/Overton_Impulse_FINAL.webm'
import yayLogo from '../../img/VoteYay_Long_4C.png'

const richardOverton = {
  header: `Richard Overton's Story`,
  headline: `What’s a better place to be safe than your house?`,
  story: [
    {
      text: (
        <div>
          <p>
            Richard Overton is America’s oldest living WWII Veteran. Since 1948,
            he has owned his own home in the heart of East Austin.
          </p>
          <p>
            Over the years, time took its toll on the home. The original wiring
            from 1948 was becoming faulty and things like the water heater were
            beginning to stop working. Mr. Overton was also in danger of
            tripping on his carpet, falling in his shower and overheating in the
            summers with no central air.
          </p>
        </div>
      ),
      media: (
        <div style={{ textAlign: 'center' }}>
          <iframe
            className="responsive-iframe"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            src="https://cbsaustin.com/embed/news/local/nations-oldest-living-ww-ii-veteran-enjoying-newly-renovated-austin-home?external-id=b4d246c1cad04f4aab1a90db3649e3f6"
          />
        </div>
      ),
    },
    {
      text: (
        <div>
          <p>This is when Meals on Wheels Central Texas stepped in.</p>
          <p>
            Through a partnership with the City, they replaced the original
            wiring in his home, installed central air and heating, widened doors
            to allow accessibility and remodeled his kitchen. They also removed
            the carpet so it was no longer a trip hazard and made his bathroom
            handicapped accessible.
          </p>
          <p>
            Now, Mr. Overton can stay in the home he has owned for 70 years and
            live a healthier, more stable life.
          </p>
        </div>
      ),
      media: (
        <div style={{ textAlign: 'center' }}>
          <video controls style={{ width: '100%', border: '3px solid black' }}>
            <source src={video} type="video/mp4" />
            <source src={videoWebm} type="video/webm" />
            <p>
              Your browser doesn't support HTML5 video. Here is a{' '}
              <a href={video}>link to the video</a> instead.
            </p>
          </video>
        </div>
      ),
    },
    {
      text: (
        <div>
          <p>
            Right now, 25% of seniors in Central Texas live under 200% of the
            poverty level. These are our neighbors who have lived in their homes
            for sometimes 3 to 4 generations, but have never been able to afford
            critical repairs needed for safe, healthy environments.
          </p>
          <p>
            Through the Affordable Housing Bond, we can help our seniors on
            fixed-incomes stay in their homes. We can keep disabled seniors like
            Mr. Overton safe.
          </p>
        </div>
      ),
      media: ``,
    },
  ],
  callToAction: (
    <div style={{ textAlign: 'center' }}>
      <img
        src={yayLogo}
        alt="Vote Yay for Prop A"
        style={{ maxWidth: '100%', marginBottom: '20px' }}
      />
      <h3>Vote Yay for Prop A on November 6th.</h3>
      <h4>Do it for your neighbors. Do it for Veterans like Mr. Overton.</h4>
    </div>
  ),
}

const RichardOvertonsStory = props => (
  <StoryTemplate
    header={richardOverton.header}
    headline={richardOverton.headline}
    story={richardOverton.story}
    callToAction={richardOverton.callToAction}
    primaryImage={props.data.richardOverton.sizes}
    secondaryImage={props.data.richardOverton2.sizes}
    thirdImage={props.data.seniors.sizes}
  />
)

const StoryHeader = ({ header, headline, secondaryImage }) => (
  <div>
    <h1 className="mb-4">{header}</h1>
    <div className="row align-items-center">
      <div className="col-sm" style={{ textAlign: 'center' }}>
        <Img
          title="Richard Overton, World War II Veteran"
          alt="Richard Overton, World War II Veteran"
          sizes={secondaryImage}
          style={{
            width: '100%',
            maxHeight: '90vh',
            border: '3px solid black',
          }}
        />
      </div>
      <h2 className="col">{headline}</h2>
    </div>
  </div>
)

const StoryTemplate = ({
  header,
  headline,
  body1,
  body2,
  story,
  callToAction,
  primaryImage,
  secondaryImage,
  thirdImage,
}) => {
  return (
    <div className="StoryTemplate container py-4">
      <StoryHeader
        header={header}
        headline={headline}
        primaryImage={primaryImage}
        secondaryImage={secondaryImage}
      />
      <div className="row py-4">
        <div
          className="col"
          style={{ borderRight: '4px dashed black', height: '100px' }}
        />
        <div className="col" />
      </div>
      <div className="row align-items-center">
        <div className="col-sm">{story[0].text}</div>
        <div className="col-sm">{story[0].media}</div>
      </div>
      <div className="row py-4">
        <div
          className="col"
          style={{ borderRight: '3px dashed black', height: '100px' }}
        />
        <div className="col" />
      </div>
      <div className="row align-items-center">
        <div className="col-sm" style={{ textAlign: 'center' }}>
          {story[1].media}
          {/* <Img
            title="Richard Overton, World War II Veteran"
            alt="Richard Overton, World War II Veteran"
            sizes={secondaryImage}
            style={{
              width: '100%',
              maxHeight: '90vh',
              border: '3px solid black',
            }}
          /> */}
        </div>
        <div className="col-sm">{story[1].text}</div>
      </div>
      <div className="row py-4">
        <div
          className="col"
          style={{ borderRight: '3px dashed black', height: '100px' }}
        />
        <div className="col" />
      </div>
      <div className="row align-items-center">
        <div className="col-sm">{story[2].text}</div>
        <div className="col-sm" style={{ textAlign: 'center' }}>
          {/* {story[2].media} */}
          <Img
            title="women laughing"
            alt="women laughing"
            sizes={thirdImage}
            style={{
              width: '100%',
              maxHeight: '90vh',
              border: '3px solid black',
            }}
          />
        </div>
      </div>
      <div className="row py-4">
        <div
          className="col"
          style={{ borderRight: '3px dashed black', height: '100px' }}
        />
        <div className="col" />
      </div>
      <div className="row">
        {callToAction}
        <StoryForm />
      </div>
    </div>
  )
}

export default RichardOvertonsStory

export const query = graphql`
  query RichardOvertonsStoryQuery {
    richardOverton: imageSharp(id: { regex: "/Richard_Overton_Photo/" }) {
      sizes(maxWidth: 600, rotate: 180) {
        ...GatsbyImageSharpSizes
      }
    }
    richardOverton2: imageSharp(id: { regex: "/overton_profile/" }) {
      sizes(maxWidth: 600, rotate: 180) {
        ...GatsbyImageSharpSizes
      }
    }
    seniors: imageSharp(id: { regex: "/rawpixel-769305-unsplash/" }) {
      sizes(maxWidth: 600, rotate: 180) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/stories/richard-overton.js